import styles from "./index.module.scss";

export default function Youtube({ id }: { id: string }): JSX.Element {
  return (
    <div className={styles.youtubeContainer}>
      <iframe
        className={styles.ytIframe}
        src={`//www.youtube.com/embed/${id}?allowfullscreen=true&autoplay=0&border=0&wmode=opaque&enablejsapi=1&controls=1&showinfo=0`}
        allowFullScreen={true}
      />
    </div>
  );
}
